import type { PunchOrderFlowState } from 'store/punchOrderFlow/punchOrderFlow.types';
import type { PunchOrderFlowDiscountsState } from 'store/punchOrderFlowDiscounts/punchOrderFlowDiscounts.types';
import type { SettingsState } from 'store/settings/settings.reducer';
import type { ValidateOrder } from 'types/ValidateOrder';
import { getBaseOrderRequestBody } from './getBaseOrderRequestBody.util';

export const getValidateOrderRequestBody = (state: {
  punchOrderFlow: PunchOrderFlowState;
  punchOrderFlowDiscounts: PunchOrderFlowDiscountsState;
  settings: SettingsState;
}): ValidateOrder | undefined => getBaseOrderRequestBody(state);
